import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BubbleProps {
    className?: string
}

// Decorative soap bubble. Position and size it with utility classes.
export const Bubble: FC<BubbleProps> = ({ className }): ReactNode => {
    return (
        <span
            aria-hidden='true'
            className={cn('bubble pointer-events-none absolute motion-safe:animate-bubble', className)}
        />
    )
}
